import __vue_component__$1 from '../../icons/action/check/IconActionCheck.vue.js';
import __vue_component__ from './HseBaseCheckboxIcon.vue.js';

//

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=679%3A183
 * @storybook /?path=/story/inputs-checkbox--playground
 * @react /src-components-checkbox
 * @reactStorybook /?path=/story/inputs-checkbox--playground
 * @requires ./HseBaseCheckboxIcon.vue
 * @requires ./HseCheckboxGroup.vue
 * @requires ./HseCheckboxIconIndeterminate.vue
 */
var script = {
  name: 'HseCheckbox',
  inheritAttrs: false,
  components: {
    HseBaseCheckboxIcon: __vue_component__
  },
  model: {
    prop: 'checked',
    event: 'change'
  },

  props: {
    /**
     * Радио-кнопка
     */
    radio: {
      type: Boolean,
      default: false
    },
    /**
     * @model
     */
    checked: {
      type: Boolean,
      default: false
    },
    /**
     * Неопределенное состояние
     */
    indeterminate: {
      type: Boolean,
      default: false
    },
    /**
     * Атрибут value у input
     */
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    /**
     * Атрибут name у input
     */
    name: {
      type: String,
      default: ''
    },
    /**
     * Подпись чекбокса
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Неактивное состояние
     */
    inactive: {
      type: Boolean,
      default: false
    },
    /**
     * Дополнительные классы элементов
     * @type {{
        input?: string,
        label?: string,
        icon?: string
     * }}
     *
     */
    classes: {
      type: Object,
      default: () => ({
        input: '',
        label: '',
        icon: ''
      })
    }
  },

  data: () => ({
    IconActionCheck: __vue_component__$1,
    focused: false
  }),

  computed: {
    isGroup() {
      return this.$parent.$options.name === 'HseCheckboxGroup';
    },
    isChecked() {
      if (!this.isGroup) return this.checked;
      if (this.$parent.modelValue) {
        if (typeof this.value === 'object') {
          return !!this.$parent.modelValue.find(
            (item) => item.id === this.value.id
          );
        }
        if (typeof this.value === 'string' || typeof this.value === 'number') {
          return !!this.$parent.modelValue.find((item) => item === this.value);
        }
      }
      return false;
    }
  },

  methods: {
    onChange() {
      /**
       * Вызывается при изменении выбранного состояния
       * @type {boolean}
       */
      this.$emit('change', !this.checked);
    },
    onFocus(e) {
      if (e.target.classList.contains('focus-visible')) {
        this.focused = true;
      }
    },
    onBlur() {
      this.focused = false;
    }
  }
};

export default script;
